module.exports = __webpack_public_path__ + "static/media/service-center-penggantian-oli-mesin.8c6296ad.jpg";